module.exports = __webpack_public_path__ + "static/media/Logo.1b405a0b.png";